import { useRef } from "react";
import { useLocation } from "react-router-dom";
import EasyloadTransactionListingPage from "./EasyloadTransactionListingPage";

const EasyloadTransactionListing = () => {
  const { state } = useLocation();
  const rechargeContactsCacheRef = useRef(null);

  return (
    <EasyloadTransactionListingPage
      key={state?.customerPhone || "__global__"}
      customerPhone={state?.customerPhone || null}
      customerName={state?.customerName || null}
      recentTransactions={state?.recentTransactions || null}
      rechargeContactsCacheRef={rechargeContactsCacheRef}
    />
  );
};

export default EasyloadTransactionListing;
